import dayjs from 'dayjs'
import { z } from 'zod'

export const serviceDateSchema = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/)
  .refine((value) => dayjs(value).isValid() && dayjs(value).format('YYYY-MM-DD') === value, '请输入有效日期')
export const serviceChargeInputSchema = z
  .object({
    feeName: z.string().trim().min(1).max(100),
    feeType: z.enum(['service', 'deposit']).default('service'),
    chargeMode: z.enum(['once', 'recurring']).default('recurring'),
    pricingUnit: z.enum(['day', 'month']).default('month'),
    unitPrice: z.number().finite().min(0).max(9_999_999_999.99).multipleOf(0.01, '金额最多保留两位小数'),
    cycleUnit: z.enum(['day', 'month']).default('month'),
    cycleInterval: z.number().int().min(1).max(365).default(1),
    billingDay: z.number().int().min(1).max(31).optional(),
    alignment: z.enum(['calendar', 'anniversary']).default('calendar'),
    prorationMode: z.enum(['actual', 'full']).default('actual'),
    generationTiming: z.enum(['start', 'end']).default('start'),
    generationOffsetDays: z.number().int().min(0).max(365).default(0),
    dueOffsetDays: z.number().int().min(0).max(365).default(5),
    autoGeneration: z.boolean().default(true)
  })
  .superRefine((value, ctx) => {
    if (value.chargeMode === 'recurring' && value.pricingUnit === 'month' && value.cycleUnit === 'day') {
      ctx.addIssue({ code: 'custom', path: ['cycleUnit'], message: '月价请选择按月出账' })
    }
    if (
      value.chargeMode === 'recurring' &&
      value.cycleUnit === 'month' &&
      ![1, 3, 6, 12].includes(value.cycleInterval)
    ) {
      ctx.addIssue({ code: 'custom', path: ['cycleInterval'], message: '按月出账支持 1、3、6、12 个月' })
    }
    if (value.feeType === 'deposit' && value.chargeMode !== 'once') {
      ctx.addIssue({ code: 'custom', path: ['chargeMode'], message: '押金只能一次性收取' })
    }
  })
export const serviceTermSchema = z
  .object({
    startAt: serviceDateSchema,
    endAt: serviceDateSchema,
    rules: z.array(serviceChargeInputSchema).min(1).max(20)
  })
  .superRefine((value, ctx) => {
    if (value.endAt < value.startAt || dayjs(value.endAt).diff(dayjs(value.startAt), 'year', true) > 20) {
      ctx.addIssue({ code: 'custom', path: ['endAt'], message: '结束日期不能早于开始日期，服务期限最长 20 年' })
    }
  })
export type ServiceTermInput = z.infer<typeof serviceTermSchema>
export type ServiceChargeInput = z.infer<typeof serviceChargeInputSchema>

export const serviceTermActionSchema = z.object({
  serviceOrderId: z.number().int().positive(),
  expectedUpdatedAt: z.date()
})
export const serviceTerminateSchema = serviceTermActionSchema.extend({
  date: serviceDateSchema,
  reason: z.string().trim().min(1).max(1000)
})
export const serviceRepriceSchema = serviceTermActionSchema.extend({
  ruleId: z.number().int().positive(),
  effectiveStart: serviceDateSchema,
  unitPrice: z.number().finite().min(0).max(9_999_999_999.99).multipleOf(0.01, '金额最多保留两位小数'),
  reason: z.string().trim().min(1).max(1000)
})
export const serviceRenewSchema = serviceTermActionSchema.extend({
  term: serviceTermSchema,
  idempotencyKey: z.uuid()
})
